import React, { useState, useEffect } from "react";
import numeral from "numeral";
import CheckBox from "../../../common/CheckBox/CheckBox";
import { useBusinessContext } from "../../../../context/business";
import { Lightbox } from "yet-another-react-lightbox";
import Video from "yet-another-react-lightbox/plugins/video";
import "yet-another-react-lightbox/styles.css";

import poster from "../../../../assets/poster.svg";

export default function ServiceSelect({ data: service }) {
  const {
    name,
    price,
    duration,
    description,
    media,
    discount_applied,
    price_before_discount,
    is_group_session,
    max_capacity,
  } = service;
  const { setSelectedBusiness, selectedBusiness } = useBusinessContext();

  // Check if this service is currently selected and get its stored quantity
  const selectedService = selectedBusiness.services.find(s => s.id === service.id);
  const isSelected = !!selectedService;
  const storedQuantity = selectedService?.quantity || 1;

  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [quantity, setQuantity] = useState(storedQuantity);
  const [showModal, setShowModal] = useState(false);
  const [pendingService, setPendingService] = useState(null);

  // Sync local quantity state with stored quantity when it changes
  useEffect(() => {
    setQuantity(storedQuantity);
  }, [storedQuantity]);

  // Check current service type in selection
  const hasGroupService = selectedBusiness.services.some(s => s.is_group_session);
  const hasIndividualService = selectedBusiness.services.some(s => !s.is_group_session);

  const currentSlides = service.media?.map((item) =>
    item.type === "image"
      ? { src: item.url, type: "image" }
      : {
          type: "video",
          sources: [{ src: item.url, type: "video/mp4" }],
        }
  );

  const extraCount = service.media?.length - 1;
  const firstItem = service.media ? service.media[0] : [];
  const handleChange = ({ currentTarget }) => {
    if (currentTarget.checked) {

      let conflictExists = false;

      if (is_group_session) {
        // If user is adding a Group Session, it conflicts with ANYTHING already in the cart
        // (No mixing with individuals, no adding a 2nd group session)
        conflictExists = selectedBusiness.services.length > 0;
      } else {
        // If user is adding an Individual Session, it only conflicts if a Group session is in the cart
        conflictExists = hasGroupService;
      }

      if (conflictExists && selectedBusiness.services.length > 0) {
        // Show confirmation modal
        const serviceWithQuantity = is_group_session
          ? { ...service, quantity }
          : service;
        setPendingService(serviceWithQuantity);
        setShowModal(true);
        // Prevent checkbox from being checked until confirmed
        currentTarget.checked = false;
        return;
      }

      // No conflict, add service directly
      const serviceWithQuantity = is_group_session
        ? { ...service, quantity }
        : service;
      setSelectedBusiness({ type: "ADD_SERVICE", data: serviceWithQuantity });
    } else {
      //delete from services
      setSelectedBusiness({ type: "REMOVE_SERVICE", data: service });
    }
  };

  const handleModalCancel = () => {
    setShowModal(false);
    setPendingService(null);
  };

  const handleModalContinue = () => {
    // Clear existing services and add the pending one
    setSelectedBusiness({ type: "RESET_SERVICES" });
    if (pendingService) {
      setSelectedBusiness({ type: "ADD_SERVICE", data: pendingService });
    }
    setShowModal(false);
    setPendingService(null);
  };

  const handleQuantityChange = (e) => {
    const newQuantity = parseInt(e.target.value, 10) || 1;
    setQuantity(newQuantity);
    // If service is already selected, update the quantity
    if (isSelected) {
      setSelectedBusiness({
        type: "UPDATE_SERVICE_QUANTITY",
        data: { id: service.id, quantity: newQuantity }
      });
    }
  };

  function WordCount(str) {
    if (str) return str.split(" ").length;
  }

  function limitWord(str, length) {
    let newStr = str.split(" "); // or newStr = [...str];
    newStr = newStr.splice(0, length);
    newStr = newStr.join(" ");
    return newStr;
  }

  function hideDesc(clicker_id) {
    let short_desc = document.getElementsByClassName(
      "clicker_" + clicker_id
    )[0];
    let long_desc = document.getElementsByClassName("closer_" + clicker_id)[0];
    if (short_desc) short_desc.style = "display:none";
    long_desc.style = "display:block";
  }
  let WordCounter = WordCount(description);
  return (
    <div>
      {/* Mutual Exclusivity Modal */}
      {showModal && (
        <div className="group-session-modal-overlay">
          <div className="group-session-modal">
            <h3>Start a new booking?</h3>
            <p>
              "{pendingService?.is_group_session
                ? pendingService.name
                : selectedBusiness.services.find(s => s.is_group_session)?.name}" cannot be booked with other services.
              This will clear your current selection.
            </p>
            <div className="group-session-modal-actions">
              <button
                type="button"
                className="cancel-btn"
                onClick={handleModalCancel}
              >
                Cancel
              </button>
              <button
                type="button"
                className="continue-btn"
                onClick={handleModalContinue}
              >
                Continue
              </button>
            </div>
          </div>
        </div>
      )}
      <div
        className="flex_block_mobile"
        style={{ justifyContent: "space-between", alignItems: "start" }}
      >
        <label className="service_select flex">
          <CheckBox onChange={handleChange} checked={isSelected} />
          <div className="text_container">
            <div className="service-name-row">
              <p>{name}</p>
              {/* {is_group_session && <span className="group-badge">GROUP</span>} */}
            </div>

            <p>
              <span>{duration} mins</span> |{" "}
              <span>₦{numeral(price).format("0,0.00")}{is_group_session ? " per person" : ""}</span>{" "}
               {discount_applied && (
                <>
                  <span className="price-strikethrough">
                    ₦{numeral(price_before_discount).format("0,0.00")}
                  </span>{" "}
                </>
              )}
            </p>
            {description ? (
              WordCounter > 50 ? (
                <div className={"clicker_" + service.id + " desc short_errr"}>
                  {" "}
                  {limitWord(description, 50)}...
                  <br></br>
                  <span
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      hideDesc(service.id);
                    }}
                    className="co_pink"
                  >
                    Continue reading
                  </span>
                </div>
              ) : (
                <div className="desc">{description}</div>
              )
            ) : (
              ""
            )}
            <div
              className={"closer_" + service.id + " desc  "}
              style={{ display: "none" }}
            >
              {description}
            </div>
          </div>
        </label>
        {is_group_session && (
          <div className="quantity-input-container">
            <label className="quantity-label">NUMBER OF PEOPLE</label>
            <div className="quantity-stepper">
              <button
                type="button"
                className="quantity-btn quantity-btn-minus"
                onClick={() => {
                  const newQty = Math.max(1, quantity - 1);
                  setQuantity(newQty);
                  if (isSelected) {
                    setSelectedBusiness({
                      type: "UPDATE_SERVICE_QUANTITY",
                      data: { id: service.id, quantity: newQty }
                    });
                  }
                }}
                disabled={quantity <= 1}
              >
                −
              </button>
              <input
                type="number"
                min="1"
                max={max_capacity || 100}
                value={quantity}
                onChange={handleQuantityChange}
                className="quantity-input"
              />
              <button
                type="button"
                className="quantity-btn quantity-btn-plus"
                onClick={() => {
                  const maxQty = max_capacity || 100;
                  const newQty = Math.min(maxQty, quantity + 1);
                  setQuantity(newQty);
                  if (isSelected) {
                    setSelectedBusiness({
                      type: "UPDATE_SERVICE_QUANTITY",
                      data: { id: service.id, quantity: newQty }
                    });
                  }
                }}
                disabled={quantity >= (max_capacity || 100)}
              >
                +
              </button>
            </div>
          </div>
        )}
        {service.media?.length > 0 ? (
          <div className="img_div">
            <div
              onClick={() => setLightboxOpen(true)}
              style={{
                position: "relative",
                width: "112px",
                height: "112px",
                cursor: "pointer",
                borderRadius: 8,
                overflow: "hidden",
                marginBottom: 16,
              }}
            >
              {firstItem.type === "image" ? (
                <img
                  src={firstItem.url}
                  alt={name}
                  loading="lazy"
                  decoding="async"
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              ) : (
                  <img
                    src={poster}
                    alt={name}
                    loading="lazy"
                    decoding="async"
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />

              )}

              {extraCount > 0 && (
                <div
                  style={{
                    position: "absolute",
                    bottom: 8,
                    right: "10px",
                    // width: "100%",
                    // height: "100%",
                    textAlign: "center",
                    alignContent: "center",
                    backgroundColor: "#000",
                    color: "#fff",
                    padding: "2px 6px",
                    fontSize: "16px",
                    borderRadius: "10px",
                    border: "1px solid #727272",
                  }}
                >
                  +{extraCount}
                </div>
              )}
            </div>

            <Lightbox
              open={lightboxOpen}
              close={() => setLightboxOpen(false)}
              slides={currentSlides}
              plugins={[Video]}
            />
          </div>
        ) : (
          /* The invisible placeholder for img */
          <div style={{ width: "112px" }}></div>
        )}
      </div>
    </div>
  );
}
